import { fromWei } from "@/lib/web3x-es/utils/units";
import { Contract } from "./Contract";

export class ERC20 extends Contract {
  protected weiUnit: any = null;

  public constructor(address: string, weiUnit = "ether", artifact?: any) {
    // eslint-disable-next-line
    super(artifact || require("./artifacts/ERC20.json"), address);
    this.weiUnit = weiUnit;
  }

  /// Read only

  public async symbol(): Promise<string> {
    return this.instance.methods.symbol().call();
  }

  public async totalSupply(): Promise<string> {
    const value = await this.instance.methods.totalSupply().call();
    return fromWei(value, this.weiUnit);
  }

  public async balanceOf(address: string): Promise<string> {
    const value = await this.instance.methods.balanceOf(address).call();
    return fromWei(value, this.weiUnit);
  }

  public async allowance(owner: string, spender: string): Promise<string> {
    return this.instance.methods.allowance(owner, spender).call();
  }

  /// Write methods

  public transfer(to: string, amount: string) {
    return this.encodeABI("transfer", to, amount);
  }

  public approve(spender: string, amount: string) {
    return this.encodeABI("approve", spender, amount);
  }

  public increaseAllowance(spender: string, amount: string) {
    return this.encodeABI("increaseAllowance", spender, amount);
  }
}
